(() => {
  if (!window.location.search) {
    return;
  }

  const url = new URL(window.location);
  const params = url.searchParams;
  const paramsToIgnore = [];

  params.forEach((value, key) => {
    if (
      key === 'q'
      || key === 'order'
      || key.startsWith('filter')
    ) {
      return;
    }

    paramsToIgnore.push(key);
  });

  paramsToIgnore.forEach((key) => {
    url.searchParams.delete(key);
  });

  if (
    !url.search
    || url.search === '?filter%5Bstreaming_type%5D=movie'
    || url.search === '?filter[streaming_type]=movie'
  ) {
    return;
  }

  document.documentElement.classList.add('has-search-params');
})();
